import React, { useState, useEffect } from "react";
import { collection, getDocs, updateDoc, doc, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";
// import { DataGrid } from "@mui/x-data-grid";
import "./rigchecksList.scss";
import { useParams } from "react-router-dom";
import SingleRigcheck from "../../components/singleRigcheck/SingleRigcheck";
import { onSnapshot } from "firebase/firestore";

const RigchecksList = () => {
  const [checks, setChecks] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  let { agency } = useParams();

  // format agency to capitalize first letter of each word
  agency = agency.replace(/\w\S*/g, (w) =>
    w.replace(/^\w/, (c) => c.toUpperCase())
  );

  // const agency = "Terryville";

  useEffect(() => {
    const getChecks = async () => {
      const agencyRigchecksCollectionRef = collection(
        db,
        "Rigchecks/VgTv80ik2BtavT0A5owc/" + agency + " Rigchecks"
      );
    
      let queryRigchecks = query(agencyRigchecksCollectionRef, orderBy("order", "desc"));

      const querySnapshot = await getDocs(queryRigchecks);
      let unsubscribe;
      if (querySnapshot.size > 0) {
        // Subscribe to the ordered collection
        unsubscribe = onSnapshot(queryRigchecks, (snapshot) => {
          // Filter out disabled checks and sub-checks (checks with isChildCheck === true)
          const list = snapshot.docs
            .map(doc => ({ ...doc.data(), id: doc.id }))
            .filter(check => !check.disabled && !check.isChildCheck);
          setChecks(list);
        });
      }
    
      // Cleanup the listener when the component is unmounted
      return () => unsubscribe();
    }

    getChecks();
  }, [agency]);

  return (
    <div
      style={{ backgroundColor: "#606060", height: "100%", minHeight: "100vh" }}
    >
      <div className="schedule-header">
        <div className="schedule-title">{agency} Rigchecks</div>
        <input
          className="search-bar"
          type="text"
          placeholder="Search checks..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="checks-container">
        {checks
          .filter((check) =>
            check.name.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .map((check) => (
            <SingleRigcheck key={check.id} check={check} />
          ))}
        {checks.length > 0 &&
          checks.filter((check) =>
            check.name.toLowerCase().includes(searchTerm.toLowerCase())
          ).length === 0 && (
            <div className="no-results">No checks found</div>
          )}
      </div>
    </div>
  );
};

export default RigchecksList;